import { UseMutationResult } from "@tanstack/react-query"
import { ErrorResponse, SuccessResponse } from "api/api"
import { Patient } from "./patientType"
import { TemplatedFormParamsAnswer } from "./templatedForm"
import { Scope } from "./user"

export const INSURANCES = {
	Medicare: { name: "Medicare" },
	Anthem: { name: "Anthem" },
	Cigna: { name: "Cigna" },
} as const

export type InsuranceKeys = keyof typeof INSURANCES

export const STATUSES = [
	"Pending",
	"Form completed",
	"Ready for fulfillment",
	"Installation date set",
	"Done",
	"Canceled",
] as const

export type Status = (typeof STATUSES)[number]

export type Enrollment = Omit<Patient, "dateOfBirth"> & {
	dateOfBirth: string
	status: Status
	createdAt?: string
	updatedAt?: string
	careOrganization?: Scope
	insurances?: { name: InsuranceKeys | "Other"; custom?: string }[]
	consentFormS3Key?: string | null
	consentFormUrl?: string | null
	medicalNecessityForm?: TemplatedFormParamsAnswer[] | null
	completionDate?: string | null
	installationDate?: string | null
	cancelDate?: string | null
	medicalRecordNumber?: string | null
	lastRecordedWeightPounds?: number | null
	notes?: string | null
}

export type EnrollmentCounts = Record<Enrollment["status"], number>

export interface EnrollmentCountsServer {
	pending: number
	formCompleted: number
	readyForFulfillment: number
	installationDateSet: number
	done: number
	canceled: number
}

export type EnrollmentTemplateSuccess = SuccessResponse<{
	fileUrl: string
}>

export type EnrollmentPayload = Partial<
	Pick<
		Enrollment,
		| "address"
		| "fullName"
		| "insurances"
		| "dateOfBirth"
		| "phoneNumber"
		| "biologicalSex"
		| "email"
		| "medicalRecordNumber"
		| "lastRecordedWeightPounds"
		| "notes"
		| "alternateContacts"
		| "completionDate"
	>
> & {
	files?: File
	isInstallationComplete?: boolean
}

export type UseMutationResultEnrollment = UseMutationResult<
	Enrollment,
	ErrorResponse,
	EnrollmentPayload,
	unknown
>
export type UseMutationResultEnrollmentToggle = UseMutationResult<
	Enrollment,
	ErrorResponse,
	Enrollment["id"],
	unknown
>
